import { useEffect } from "react";
import { applyWebSeo } from "../../../web/seo/applyWebSeo";
import { homeSeo } from "../../../web/seo/homeSeo";
import { hpnSeo, manhattanPrivateCarSeo, newYorkTransportationSeo, onlineBookingSeo, westchesterAirportSeo, yorktownHeightsBlackCarSeo } from "../../../web/seo/webSeoConfig";

const routeContent = {
  "/": homeSeo,
  "/hpn-airport-car-service": hpnSeo,
  "/westchester-airport-car-service": westchesterAirportSeo,
  "/yorktown-heights-black-car-service": yorktownHeightsBlackCarSeo,
  "/manhattan-private-car-service": manhattanPrivateCarSeo,
  "/jet-black-transportation": newYorkTransportationSeo,
  "/online-booking": onlineBookingSeo,
};

const normalizePath = (pathname) => pathname.replace(/\/+$/, "") || "/";

function MobileSeoServiceSection({ pathname }) {
  const seo = routeContent[normalizePath(pathname)];

  useEffect(() => {
    if (!seo) return undefined;
    return applyWebSeo(seo);
  }, [seo]);

  return null;
}

export default MobileSeoServiceSection;
